/**
 * Filkhedma API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ForceUpdateOrderVisit } from './forceUpdateOrderVisit';
import { Technician } from './technician';


export interface ForceUpdateOrderVisitRequest { 
    orderId?: string;
    servicesChecksum?: string;
    visit?: ForceUpdateOrderVisit;
    visitTechnician?: Technician;
    responsible?: ForceUpdateOrderVisitRequest.ResponsibleEnum;
    reason?: string;
}
export namespace ForceUpdateOrderVisitRequest {
    export type ResponsibleEnum = 'operations' | 'customer_care' | 'technician' | 'customer';
    export const ResponsibleEnum = {
        Operations: 'operations' as ResponsibleEnum,
        CustomerCare: 'customer_care' as ResponsibleEnum,
        Technician: 'technician' as ResponsibleEnum,
        Customer: 'customer' as ResponsibleEnum
    };
}
